// extracted by mini-css-extract-plugin
module.exports = {"contentPolicies":"TextPages_contentPolicies__1EIYL","nav_nav_link":"TextPages_nav_nav_link__3D3q0"};